import { useState } from "react";

export default function ContractSignModal({ onClose, onSign }: { onClose: () => void; onSign: () => void }) {
  const [step, setStep] = useState<"preview" | "confirm" | "done">("preview");
  const [agreed, setAgreed] = useState(false);
  const [signing, setSigning] = useState(false);
  const handleSign = () => {
    if (!agreed) return;
    setSigning(true);
    setTimeout(() => { setSigning(false); setStep("done"); }, 1500);
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center" style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}>
      <div className="bg-white rounded-t-3xl w-full" style={{ maxWidth: 480, maxHeight: "92vh", display: "flex", flexDirection: "column" }}>
        <div className="w-10 h-1 rounded-full bg-gray-200 mx-auto mt-3 flex-shrink-0" />
        <div className="flex items-center justify-between px-5 pt-4 pb-3 flex-shrink-0" style={{ borderBottom: "1px solid #F5F5F5" }}>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full cursor-pointer" style={{ background: "#F4F5F9" }}>
            <i className="ri-close-line" style={{ color: "#374151", fontSize: 18 }} />
          </button>
          <span className="text-base font-bold text-gray-900">{step === "done" ? "签约完成" : "合同签署"}</span>
          <div className="w-8" />
        </div>
        {step !== "done" && (
          <div className="flex items-center justify-center gap-3 px-5 py-3 flex-shrink-0">
            {["阅读合同", "确认签署"].map((s, i) => {
              const activeIdx = step === "preview" ? 0 : 1;
              const done = activeIdx > i;
              const active = activeIdx === i;
              return (
                <div key={s} className="flex items-center gap-1.5">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold" style={{ background: done || active ? "#1E3A8A" : "#EEF0F5", color: done || active ? "#fff" : "#9CA3AF" }}>
                    {done ? <i className="ri-check-line" style={{ fontSize: 10 }} /> : i + 1}
                  </div>
                  <span className="text-xs" style={{ color: done || active ? "#1E3A8A" : "#9CA3AF", fontWeight: active ? 600 : 400 }}>{s}</span>
                  {i === 0 && <div className="w-8 h-px" style={{ background: step === "confirm" ? "#1E3A8A" : "#E5E7EB" }} />}
                </div>
              );
            })}
          </div>
        )}
        <div className="flex-1 overflow-y-auto px-5 pb-5">
          {step === "preview" && (
            <div>
              <div className="text-center py-4 mb-3" style={{ borderBottom: "1px solid #F5F5F5" }}>
                <div className="text-base font-bold text-gray-900">旅游服务合同</div>
                <div className="text-xs text-gray-400 mt-1">合同编号：CT20250413003</div>
              </div>
              <div className="space-y-4 text-xs text-gray-600 leading-relaxed">
                {[{ title: "甲方（旅游者）", rows: [["姓名", "林晓雨"], ["证件号", "310***********1234"], ["联系电话", "138****8888"]] }, { title: "乙方（旅行社）", rows: [["公司名称", "美伊国际旅行社有限公司"], ["许可证号", "L-SC00123"], ["联系电话", "400-888-8888"]] }].map((block) => (
                  <div key={block.title}>
                    <div className="font-bold text-gray-800 mb-1.5">{block.title}</div>
                    <div className="rounded-2xl p-3 space-y-1.5" style={{ background: "#F8F8F8" }}>
                      {block.rows.map(([l, v]) => (
                        <div key={l} className="flex justify-between"><span className="text-gray-400">{l}</span><span className="font-medium text-gray-700">{v}</span></div>
                      ))}
                    </div>
                  </div>
                ))}
                <div>
                  <div className="font-bold text-gray-800 mb-1.5">退改政策</div>
                  <div className="rounded-2xl p-3 space-y-1.5" style={{ background: "#FFF7ED" }}>
                    {["出发前7天（含）：免费取消，全额退款", "出发前3~7天：退款70%，手续费30%", "出发前3天内：不予退款"].map((s) => (
                      <div key={s} className="flex items-start gap-2"><span className="text-orange-400 flex-shrink-0 mt-0.5">·</span><span>{s}</span></div>
                    ))}
                  </div>
                </div>
              </div>
              <button onClick={() => setStep("confirm")} className="w-full mt-5 py-3.5 rounded-2xl text-sm font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: "#1E3A8A" }}>已阅读，进入签署</button>
            </div>
          )}
          {step === "confirm" && (
            <div className="pt-2">
              <div className="mb-4">
                <div className="text-xs font-semibold text-gray-600 mb-2">手写签名</div>
                <div className="rounded-2xl flex items-center justify-center cursor-pointer" style={{ height: 110, background: "#F8F8F8", border: "2px dashed #D1D5DB" }}>
                  <div className="text-center"><i className="ri-edit-2-line" style={{ color: "#C4C8D0", fontSize: 26 }} /><div className="text-xs text-gray-400 mt-1.5">点击在此签名</div></div>
                </div>
              </div>
              <button onClick={() => setAgreed(!agreed)} className="flex items-start gap-3 cursor-pointer mb-5 w-full text-left">
                <div className="w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5 transition-all" style={{ background: agreed ? "#1E3A8A" : "transparent", border: `2px solid ${agreed ? "#1E3A8A" : "#D8DAE0"}` }}>
                  {agreed && <i className="ri-check-line text-white" style={{ fontSize: 11 }} />}
                </div>
                <span className="text-xs text-gray-500 leading-relaxed">我已认真阅读并同意<span style={{ color: "#1E3A8A" }}>《旅游服务合同》</span>及<span style={{ color: "#1E3A8A" }}>《用户服务协议》</span></span>
              </button>
              <button onClick={handleSign} disabled={!agreed || signing} className="w-full py-3.5 rounded-2xl text-sm font-semibold cursor-pointer whitespace-nowrap" style={{ background: agreed ? "#1E3A8A" : "#EEF0F5", color: agreed ? "#fff" : "#9CA3AF" }}>
                {signing ? <span className="flex items-center justify-center gap-2"><i className="ri-loader-4-line animate-spin" />签署中...</span> : "确认签署合同"}
              </button>
            </div>
          )}
          {step === "done" && (
            <div className="flex flex-col items-center justify-center py-8">
              <div className="w-20 h-20 rounded-full flex items-center justify-center mb-4" style={{ background: "#ECFDF5" }}>
                <i className="ri-checkbox-circle-fill" style={{ color: "#10B981", fontSize: 44 }} />
              </div>
              <div className="text-xl font-bold text-gray-900 mb-1.5">签约成功！</div>
              <div className="text-sm text-gray-500 text-center mb-6">合同已签署，旅行社将尽快安排行程</div>
              <div className="flex gap-3 w-full">
                <button onClick={onClose} className="flex-1 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap" style={{ background: "#F4F5F9", color: "#6B7280" }}>关闭</button>
                <button onClick={onSign} className="flex-1 py-3 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap" style={{ background: "#1E3A8A" }}>查看合同</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
